import {Component, OnInit} from '@angular/core';
import {MercadoriasColoracaoService} from "./mercadorias-coloracao.service";
import {MercadoriasColoracaoModel} from "./mercadorias-coloracao.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {TranslateService} from '@ngx-translate/core';
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-mercadorias-coloracao',
  templateUrl: './mercadorias-coloracao.component.html'
})
export class MercadoriasColoracaoComponent extends Components implements OnInit {

  coloracaoes: MercadoriasColoracaoModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private mercadoriasColoracaoService: MercadoriasColoracaoService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'mercadorias'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.mercadoriasColoracaoService.getPaginacao(1,this.itensPorPagina, ["mercadoria"])
      .subscribe(data => {
        this.coloracaoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.coloracaoes);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });


  }

  delete(coloracao) {
    let coloracaoes = this.coloracaoes;
    let mercadoriasColoracaoService = this.mercadoriasColoracaoService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarColoracao')+coloracao.nome_pt,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(coloracaoes);
        }

        let index = coloracaoes.indexOf(coloracao);
        coloracaoes.splice(index, 1);

        mercadoriasColoracaoService.apagar(coloracao.id_coloracao)
          .subscribe(res => {
              self.coloracaoes = coloracaoes;
            },
            err => {
              // Revert the view back to its original state
              coloracaoes.splice(index, 0, coloracao);
              self.coloracaoes = coloracaoes;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.mercadoriasColoracaoService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.coloracaoes = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias-coloracao/mercadorias-coloracao.component.ts